<template>
  <div class="passwordetail">
    <navBack title="信息变更"></navBack>
    <div class="passwordetail_title">
      <p>信息变更</p>
    </div>
    <div class="" style="padding: 20px">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="applyTime" label="修改时间" align="center">
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.applyTime) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="type" label="类型" align="center">
				</el-table-column> -->
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.status == 0
                ? "待审核"
                : scope.row.status == 1
                ? "已通过"
                : "驳回"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="动作" align="center">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
      :hide-on-single-page="true"
      style="text-align: center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { formatDate } from "@/utils/formatTime.js";
import navBack from "../../components/navBack.vue";
import { getChangeRecord } from "../../api/moudles/user.js";
export default {
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      totalNum: 0,
    };
  },
  components: {
    navBack,
  },
  computed: mapState({
    // 箭头函数可使代码更简练
    userInfo: (state) => state.user.userInfo,
  }),
  created() {
    this.getChangeRecord();
  },
  methods: {
    formatDate,
    handleSizeChange(val) {
      this.pageSize = val;
      this.getChangeRecord();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getChangeRecord();
    },
    handleClick(row) {
      this.$router.push(`/changeDetail/${row.code}`);
    },
    async getChangeRecord() {
      await getChangeRecord({
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          memberCode: this.userInfo.memberCode,
        },
        success: (res) => {
          console.log("获取信息变更记录", res);
          this.tableData = res.data.list;
          this.totalNum = parseInt(res.data.total);
        },
      });
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .passwordetail_title {
    display: none;
  }
  .passwordetail {
    min-height: 700px;
    background-color: #fff;
    padding-bottom: 60px;
  }
}
@media screen and (min-width: 750px) {
  .passwordetail_title {
    height: 60px;
    font-weight: 500;
    font-size: 22px;
    line-height: 60px;
    padding-left: 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .passwordetail {
    min-height: 650px;
    background-color: #fff;
    padding-bottom: 20px;
  }
}
</style>
